import React from 'react';
import { ArrowDown } from 'lucide-react';
import { useNavigation } from '../../hooks/useNavigation';

export function LoadMoreButton() {
  const { navigateToSection } = useNavigation();

  const handleClick = () => {
    navigateToSection('waitlist');
  };

  return (
    <div className="text-center mt-12 space-y-4">
      <button
        onClick={handleClick}
        className="group inline-flex items-center gap-2 bg-white dark:bg-gray-800 text-primary-500 
          px-6 py-3 rounded-lg border-2 border-primary-500 hover:bg-primary-50 dark:hover:bg-gray-700
          transition-all duration-200 font-medium"
      >
        <ArrowDown className="w-4 h-4 transition-transform group-hover:translate-y-0.5" />
        Load More Questions
      </button>
      <p className="text-sm text-gray-500 dark:text-gray-400">
        Join our waitlist to access the full Q&A community
      </p>
    </div>
  );
}